import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: 'input[numbersOnly]'
})
export class NumberDirective {

    constructor(private _el: ElementRef) {
    }

    // event keyCode are 8,13,48,57
    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this._el.nativeElement.value.toString().replace(/[^0-9]*/g, '');
        this._el.nativeElement.value = initalValue;
        if (this._el.nativeElement.name !== 'last4SSN') {
            this._el.nativeElement.value = initalValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
